function readValue(source, keys) {
  for (const key of keys) {
    if (source && Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined && source[key] !== null) {
      return source[key];
    }
  }
  return undefined;
}

function getText(value) {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number") return String(value).trim();
  return String(value).trim();
}

function getBoolean(value) {
  const text = getText(value).toUpperCase();
  if (text === "") return false;
  return ["TRUE", "YES", "VERIFIED", "CONFIRMED", "ENABLED", "ACTIVE"].includes(text);
}

export function getProfileAccountState(user = {}) {
  const displayName = getText(readValue(user, ["display_name", "displayName", "name"]));
  const username = getText(readValue(user, ["username", "login", "login_id", "user_name"]));
  const email = getText(readValue(user, ["email", "email_address", "primary_email"]));
  const phone = getText(readValue(user, ["phone", "phone_number", "mobile", "phoneNumber"]));
  const avatarUrl = getText(readValue(user, ["avatar_url", "avatarUrl", "avatar", "profile_image", "thumbnail_url", "thumbnailUrl"]));

  const emailVerified = getBoolean(readValue(user, ["email_verified", "emailVerified", "email_verification_state", "emailVerificationState"]));
  const phoneVerified = getBoolean(readValue(user, ["phone_verified", "phoneVerified", "phone_verification_state", "phoneVerificationState"]));

  return {
    displayName,
    username,
    email,
    phone,
    avatarUrl,
    emailVerified,
    phoneVerified,
    supportsProfileWrite: false,
    supportsPasswordChange: false,
    supportsAvatarUpload: false,
    profileWriteStatus: "Not available in the current backend contract",
    passwordStatus: "Password changes require an approved server-side authentication contract",
  };
}
